import { fetchApi } from '@utils/api/client';
import { WRPayment, WRPromoCode } from '@utils/api/server';
import { User } from 'types/user';

async function fetchUser(setUser: (user: User | null) => void, accessToken: string) {
  const res = await fetch(`${process.env.NEXT_PUBLIC_API_PUBLIC}/users/profile/me`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  const user = await res.json();

  setUser(user);
}

export type MinePayment = WRPayment & {
  promoCode: WRPromoCode | undefined;
};

async function fetchPayments(setPayments: (payments: any) => void) {
  if (process.env.USE_MOCK_PAYMENTS === 'true') {
    const mockPayments: WRPayment[] = [
      // mock payment objects here
      {
        id: 2,
        title: 'Mock Payment 2',
        session_id: 'def456',
        expires_at: 1709039026,
        created_at: 1708524230,
        amount: 3000,
        discount_percentage: 20,
        total_amount: 1600,
        currency: 'PLN',
        description: 'Mock payment description 2',
        country: 'PL',
        client: 'Mock Client 2',
        address: '456 Mock Street',
        zip: '12345',
        city: 'Mock City',
        email: 'mock2@example.com',
        phone: '123-456-7890',
        company_name: 'Mock Company 2',
        company_nip: '987654321',
        company_address: '789 Mock Street',
        company_zip: '54321',
        company_city: 'Mock City',
        company_country: 'US',
        status: 'paid',
        package_name: 'premium-monthly',
        probe_payment: true,
        payment_status: 'PAID',
        user_id: 2,
        user_count: 3,
        user_emails: ['mock2@example.com'],
        auto_renew: true,
        invoice_number: '123456',
      },
      {
        id: 3,
        title: 'Mock Payment 3',
        session_id: 'ghi789',
        expires_at: 1635724800,
        created_at: 1635638400,
        amount: 3000,
        discount_percentage: 30,
        total_amount: 2100,
        currency: 'PLN',
        description: 'Mock payment description 3',
        country: 'PL',
        client: 'Mock Client 3',
        address: '789 Mock Street',
        zip: '12345',
        city: 'Mock City',
        email: 'mock3@example.com',
        phone: '123-456-7890',
        company_name: 'Mock Company 3',
        company_nip: '987654321',
        company_address: '789 Mock Street',
        company_zip: '54321',
        company_city: 'Mock City',
        company_country: 'US',
        status: 'paid',
        package_name: 'premium-monthly',
        probe_payment: true,
        payment_status: 'NEW',
        user_id: 3,
        user_count: 4,
        user_emails: ['mock3@example.com'],
        auto_renew: false,
        invoice_number: '123456',
      },
    ];

    setPayments(mockPayments);
    return;
  }
  await fetchApi<MinePayment[]>(`${process.env.NEXT_PUBLIC_BASE_URL}/apis/premium/payment/mine`).then((res) => {
    setPayments(res.data);
  });
}

export { fetchPayments, fetchUser };
